module.exports = __webpack_public_path__ + "static/media/iconmonstr-cloud-30.55bfc58d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/iconmonstr-cloud-30.svg
// module id = 724
// module chunks = 0